import { ForkEffect, all, put, takeEvery } from 'redux-saga/effects';
import { REDUX_APP_SET_WEATHER_WARNING_BANNER } from 'redux-state/app/reducer.js';
import {
  REDUX_WEATHER_WARNINGS_CLEAR,
  REDUX_WEATHER_WARNINGS_FETCH_INIT,
} from 'redux-state/weather-warnings/reducer.js';
import { LayoutAction, REDUX_LAYOUT_SET } from './reducer.js';

// Triggers getWarnings when layout is updated
function* getWarnings({ payload }: LayoutAction) {
  const pageLoc = payload.screen?.location;
  if (pageLoc) {
    const warningProps = { type: pageLoc.type, key: pageLoc.key };
    const action = { warningProps, timestamp: Date.now() };
    /**
     * new page so make sure warning banner is closed
     * clear warnings in redux
     * fetch new warnings for page location
     */
    yield all([
      put(REDUX_APP_SET_WEATHER_WARNING_BANNER({ isOpen: false })),
      put(REDUX_WEATHER_WARNINGS_CLEAR()),
      put(REDUX_WEATHER_WARNINGS_FETCH_INIT(action)),
    ]);
  }
}

/**
 * When layout is set then clear warnings and fetch for this page
 * This prevents mismatching with other pages e.g. regions in marine can match regions in land
 */
export default function* layoutSaga(): IterableIterator<ForkEffect<never>> {
  const action = REDUX_LAYOUT_SET({ timestamp: Date.now() }).type;
  yield takeEvery(action, getWarnings);
}
